<div class="bg-blue-main">
  <div class="card">
    <div class="card-header flex-between">
      <h5>{{ pageHeading }}</h5>
      <div class="flex-start info-summary">
        <span class="border-right">
          <div class="text-bold">Subscription</div>
          <div>{{ accountId || "-" }}</div>
        </span>
        <span class="border-right">
          <div class="text-bold">Recommendations</div>
          <div>{{ totalRecommendationCount }}</div>
        </span>
        <button class="btn btn-light" (click)="refresh(true)">Refresh</button>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="card">
      <div class="card-body table-acm-container">
        <div class="pink_margin">
          {{ recommendationSummary }}
        </div>
        <div class="flex_gap10 summary-line">
          <div>Potential Monthly Saving:</div>
          <div>
            <span class="green_text fontsize_em">{{ getTotalSavings() }} {{ savingsCurrencyLabel }}</span>
          </div>
          <div class="annual-savings">Annual: {{ getTotalAnnualSavings() }} {{ savingsCurrencyLabel }}</div>
          <div *ngIf="loading">
            <img src="../assets/img/loading_2.svg" alt="loading recommendations" class="width15_margin10" />
          </div>
        </div>

        <div class="overflow_auto2">
          <table class="table table-docs table-hover cost-table">
            <thead>
              <tr>
                <th>S.N.</th>
                <th *ngFor="let h of headers">
                  {{ h.name }}
                  <span *ngIf="h.filter" class="inputseach">
                    <input autocomplete="off" type="text" [(ngModel)]="h.filterText" />
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </span>
                </th>
              </tr>
            </thead>

            <tbody
              [ngStyle]="{ display: vmOptimizations.length > 0 ? 'table-row-group' : 'none' }"
              *ngFor="let item of vmOptimizations | paginate : { itemsPerPage: pagination['perPage'], currentPage: pagination['page'], totalItems: vmOptimizations.length }; let i = index"
            >
              <tr *ngIf="notifier.filterTableColums(headers, item)">
                <td>{{ pagination["perPage"] * (pagination["page"] - 1) + i + 1 }}</td>
                <td *ngFor="let h of headers">{{ getCellValue(item, h.id) }}</td>
              </tr>
            </tbody>

            <tbody *ngIf="vmOptimizations.length == 0 && !fetching">
              <tr>
                <td [attr.colspan]="headers.length + 1" class="center">
                  No RI recommendations found for the selected subscription.
                </td>
              </tr>
            </tbody>

            <tbody *ngIf="fetching">
              <tr>
                <td [attr.colspan]="headers.length + 1" class="center">
                  <div class="flex-center">
                    <img src="../assets/img/loading_2.svg" alt="loading recommendations" class="width-18" />
                    <span>Loading recommendations...</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginator">
          <div class="flex-start">
            <span class="no-wrap">Per Page</span>
            <select class="form-select" [(ngModel)]="pagination['perPage']" (change)="pagination['page'] = 1">
              <option value="{{ page }}" *ngFor="let page of pages">{{ page }}</option>
            </select>
          </div>
          <pagination-controls
            class="pagination"
            previousLabel="Prev"
            nextLabel="Next"
            (pageChange)="pagination['page'] = $event"
          >
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
